// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects {
  padding: 8rem 0;
  background: #050505;
  position: relative;
}

.projects-list {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.project-item {
  position: relative;
  display: grid;
  grid-template-columns: 80px 1fr 200px 80px;
  align-items: center;
  gap: 2rem;
  padding: 2rem 0;
  cursor: pointer;
  transition: background 0.3s;
}

.project-item:hover {
  background: rgba(191,0,255,0.03);
}

.project-line {
  position: absolute;
  bottom: 0; left: 0;
  width: 100%;
  height: 1px;
  background: rgba(255,255,255,0.06);
}

.project-item:hover .project-line {
  background: rgba(191,0,255,0.2);
}

.project-number {
  font-family: monospace;
  font-size: 0.7rem;
  color: rgba(255,255,255,0.2);
  letter-spacing: 0.1em;
}

.project-category {
  font-size: 0.7rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  display: block;
  margin-bottom: 0.4rem;
}

.project-title {
  font-size: clamp(1.2rem, 3vw, 2rem);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(255,255,255,0.85);
  transition: color 0.3s;
}

.project-item:hover .project-title {
  color: #fff;
}

.project-placeholder {
  width: 200px;
  height: 120px;
  background: #111;
  border: 1px solid rgba(255,255,255,0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.placeholder-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.7rem;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: rgba(255,255,255,0.2);
}

.placeholder-inner span:first-child {
  font-size: 1.5rem;
  animation: pulsePlaceholder 2s ease-in-out infinite;
}

@keyframes pulsePlaceholder {
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
}

.project-year {
  font-size: 0.75rem;
  color: rgba(255,255,255,0.25);
  letter-spacing: 0.1em;
  text-align: right;
}

.projects-cta {
  text-align: center;
  margin-top: 4rem;
  padding-top: 3rem;
  border-top: 1px solid rgba(255,255,255,0.05);
}

.projects-cta p {
  font-size: 0.9rem;
  color: rgba(255,255,255,0.3);
  letter-spacing: 0.05em;
}

@media (max-width: 768px) {
  .project-item {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  .project-placeholder { width: 100%; }
  .project-number, .project-year { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Projects.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,OAAO;EAClB,WAAW;EACX,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,UAAU,EAAE;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA,uBAAuB,WAAW,EAAE;EACpC,iCAAiC,aAAa,EAAE;AAClD","sourcesContent":[".projects {\n  padding: 8rem 0;\n  background: #050505;\n  position: relative;\n}\n\n.projects-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.project-item {\n  position: relative;\n  display: grid;\n  grid-template-columns: 80px 1fr 200px 80px;\n  align-items: center;\n  gap: 2rem;\n  padding: 2rem 0;\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.project-item:hover {\n  background: rgba(191,0,255,0.03);\n}\n\n.project-line {\n  position: absolute;\n  bottom: 0; left: 0;\n  width: 100%;\n  height: 1px;\n  background: rgba(255,255,255,0.06);\n}\n\n.project-item:hover .project-line {\n  background: rgba(191,0,255,0.2);\n}\n\n.project-number {\n  font-family: monospace;\n  font-size: 0.7rem;\n  color: rgba(255,255,255,0.2);\n  letter-spacing: 0.1em;\n}\n\n.project-category {\n  font-size: 0.7rem;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  display: block;\n  margin-bottom: 0.4rem;\n}\n\n.project-title {\n  font-size: clamp(1.2rem, 3vw, 2rem);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: rgba(255,255,255,0.85);\n  transition: color 0.3s;\n}\n\n.project-item:hover .project-title {\n  color: #fff;\n}\n\n.project-placeholder {\n  width: 200px;\n  height: 120px;\n  background: #111;\n  border: 1px solid rgba(255,255,255,0.06);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  position: relative;\n}\n\n.placeholder-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.7rem;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: rgba(255,255,255,0.2);\n}\n\n.placeholder-inner span:first-child {\n  font-size: 1.5rem;\n  animation: pulsePlaceholder 2s ease-in-out infinite;\n}\n\n@keyframes pulsePlaceholder {\n  0%, 100% { opacity: 0.4; }\n  50% { opacity: 1; }\n}\n\n.project-year {\n  font-size: 0.75rem;\n  color: rgba(255,255,255,0.25);\n  letter-spacing: 0.1em;\n  text-align: right;\n}\n\n.projects-cta {\n  text-align: center;\n  margin-top: 4rem;\n  padding-top: 3rem;\n  border-top: 1px solid rgba(255,255,255,0.05);\n}\n\n.projects-cta p {\n  font-size: 0.9rem;\n  color: rgba(255,255,255,0.3);\n  letter-spacing: 0.05em;\n}\n\n@media (max-width: 768px) {\n  .project-item {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  .project-placeholder { width: 100%; }\n  .project-number, .project-year { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
